const STORAGE_PREFIX = 'we-tree:treeRecents:';
const MAX_RECENTS = 6;

export function getTreeRecentAnchors(familyId: string): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${familyId}`);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is string => typeof id === 'string' && id.length > 0);
  } catch {
    return [];
  }
}

/** Record a prior anchor when re-anchoring the tree on someone else. */
export function pushTreeRecentAnchor(familyId: string, previousAnchorId: string, newAnchorId: string): void {
  if (!previousAnchorId || previousAnchorId === newAnchorId || previousAnchorId.startsWith('placeholder-')) {
    return;
  }
  try {
    const existing = getTreeRecentAnchors(familyId).filter((id) => id !== newAnchorId && id !== previousAnchorId);
    const next = [previousAnchorId, ...existing].slice(0, MAX_RECENTS);
    sessionStorage.setItem(`${STORAGE_PREFIX}${familyId}`, JSON.stringify(next));
  } catch {
    // ignore
  }
}
